// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import { GridWidths } from "@insite/mobius/GridItem";
import { orderInfoStyle } from "@rugby/App/WidgetExtensions/MyAccountPagesSharedStyle/DetailsPage.style";
import { rfqConfirmationDetailsStyles } from "@rugby/Overrides/Widgets/RfqConfirmation/RfqConfirmationDetails";

const headingAndText: SmallHeadingAndTextStyles = {
    heading: {
        transform: "initial",
        weight: 700,
        size: 16,
        color: "text.main",
    },
};

const dateGridItemWidth: GridWidths | GridWidths[] = [12, 6, 4, 4, 4];
rfqConfirmationDetailsStyles.dateGridItem!.width = dateGridItemWidth;
rfqConfirmationDetailsStyles.statusGridItem!.width = dateGridItemWidth;
rfqConfirmationDetailsStyles.salesRepGridItem!.width = dateGridItemWidth;
rfqConfirmationDetailsStyles.jobNameGridItem!.width = dateGridItemWidth;

rfqConfirmationDetailsStyles.jobNameHeadingAndText = headingAndText;
rfqConfirmationDetailsStyles.salesRepHeadingAndText = headingAndText;
rfqConfirmationDetailsStyles.statusHeadingAndText = headingAndText;
rfqConfirmationDetailsStyles.customerHeadingAndText = headingAndText;
rfqConfirmationDetailsStyles.shipToHeadingAndText = headingAndText;
rfqConfirmationDetailsStyles.poNumberHeadingAndText = headingAndText;
rfqConfirmationDetailsStyles.notesHeadingAndText = headingAndText;
rfqConfirmationDetailsStyles.dateLabelText = orderInfoStyle.orderLabel;
